/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getLocations } from '../fn/locations/get-locations';
import { GetLocations$Params } from '../fn/locations/get-locations';
import { LocationsResponse } from '../models/locations-response';
import { LocationsUpdateResponse } from '../models/locations-update-response';
import { updateLocations } from '../fn/locations/update-locations';
import { UpdateLocations$Params } from '../fn/locations/update-locations';

@Injectable({ providedIn: 'root' })
export class LocationsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getLocations()` */
  static readonly GetLocationsPath = '/api/v1/location';

  /**
   * Get location for named ressources.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLocations()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLocations$Response(params?: GetLocations$Params, context?: HttpContext): Observable<StrictHttpResponse<LocationsResponse>> {
    return getLocations(this.http, this.rootUrl, params, context);
  }

  /**
   * Get location for named ressources.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLocations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLocations(params?: GetLocations$Params, context?: HttpContext): Observable<LocationsResponse> {
    return this.getLocations$Response(params, context).pipe(
      map((r: StrictHttpResponse<LocationsResponse>): LocationsResponse => r.body)
    );
  }

  /** Path part for operation `updateLocations()` */
  static readonly UpdateLocationsPath = '/api/v1/location';

  /**
   * Endpoint to update location of resources.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateLocations()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLocations$Response(params: UpdateLocations$Params, context?: HttpContext): Observable<StrictHttpResponse<LocationsUpdateResponse>> {
    return updateLocations(this.http, this.rootUrl, params, context);
  }

  /**
   * Endpoint to update location of resources.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateLocations$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLocations(params: UpdateLocations$Params, context?: HttpContext): Observable<LocationsUpdateResponse> {
    return this.updateLocations$Response(params, context).pipe(
      map((r: StrictHttpResponse<LocationsUpdateResponse>): LocationsUpdateResponse => r.body)
    );
  }

}
